<template>
  <el-dialog
    width="70%"
    :before-close="handleClose"
    :visible.sync="isOpen"
    :close-on-click-modal="false"
  >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="成绩统计" name="0">
        <div class="content" :style="{height:testInfo.review_option&&testInfo.review_option.includes('answer')?'100%':'400px'}">
          <img :src="testUserInfo.avatar" class="avtar_img">
          <div class="name">{{ testUserInfo.realname }}</div>
          <div class="status">交卷成功</div>
          <div v-if="testInfo.review_option&&testInfo.review_option.includes('answer')&&testInfo.review_option.length>1&&examDetailed.review==0" class="tips">考试整体结束时可以通过回顾考试查看考试相关统计数据</div>
          <div v-if="testInfo.review_option&&testInfo.review_option.includes('answer')&&testInfo.review_option.length>1&&examDetailed.review==1" class="tips">可以通过回顾考试查看考试相关统计数据 </div>
          <div v-if="!testInfo.review_option||testInfo.review_option&&!testInfo.review_option.includes('answer')" class="tips2">本场考试不在系统中公布成绩有问题请联系管理员 </div>
          <div class="progress_box">
            <div v-show="testInfo.review_option&&testInfo.review_option.includes('answer')" id="myChart" class="myChart" />
            <div class="progress_text">
              <div v-if="testInfo.review_option&&testInfo.review_option.includes('answer')">得分</div>
              <div v-if="testInfo.review_option&&testInfo.review_option.includes('answer')" class="progress_scope">{{ testUserInfo.score }}</div>
              <div>用时 {{ testUserInfo.time |filterTime }}</div>
            </div>
            <span v-if="testInfo.review_option&&testInfo.review_option.includes('answer')">
              <span v-if="testUserInfo.pass==='及格'" class="tags cor1">及格</span>
              <span v-else-if="testUserInfo.pass==='不及格'" class="tags cor2">不及格</span>
              <span v-else class="tags cor3">漏考</span>
            </span>

          </div>
          <!-- <div v-else class="exam_name">本场考试不在系统中公布成绩</div> -->
          <div class="exam_name"> {{ examDetailed.title }}</div>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="排名统计" name="1">
        <div v-if="testInfo.review_option&&testInfo.review_option.includes('rank')">
          <div v-if="examDetailed.answer_number!=1&&examDetailed.statistics==3" class="tab_tips"><img src="@/assets/img/data.png" class="data_img">注意：本场考试可多次作答，排名方式是按得分最高的一次成绩排名的</div>
          <div v-if="examDetailed.answer_number!=1&&examDetailed.statistics==2" class="tab_tips"><img src="@/assets/img/data.png" class="data_img">注意：本场考试可多次作答，排名方式是按最后一次成绩排名的</div>
          <div v-if="examDetailed.answer_number!=1&&examDetailed.statistics==1" class="tab_tips"><img src="@/assets/img/data.png" class="data_img">注意：本场考试可多次作答，排名方式是按第一次成绩排名的</div>
          <el-table
            :header-cell-style="{background:'#F7F8FA',fontSize: '14px',color:'#606060'}"
            :data="tableData"
            :cell-style="{fontSize: '14px',color:'#303030',borderColor:'#eeeee'}"
            style="width: 100%"
            :row-style="rowStyle"
            height="500"
          >
            <el-table-column
              prop="date"
              label="排名"
            >
              <template slot-scope="scope">
                <img v-if="scope.row.rank==1" src="@/assets/img/no1.png" class="no_img">
                <img v-else-if="scope.row.rank==2" src="@/assets/img/no2.png" class="no_img">
                <img v-else-if="scope.row.rank==3" src="@/assets/img/no3.png" class="no_img">
                <div v-else>{{ scope.row.rank }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="realname"
              label="姓名"
            >
              <template slot-scope="scope">
                <div class="table_user">
                  <img :src="scope.row.avatar" class="user_img">{{ scope.row.realname }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="score"
              label="得分"
            >
              <template slot-scope="scope">{{ scope.row.score }}分</template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="答题时长"
            >
              <template slot-scope="scope">{{ scope.row.exam_time |filterTime }}</template>
            </el-table-column>
            <el-table-column
              prop="right"
              label="正确数"
            />
            <el-table-column
              prop="wrong"
              label="错误数"
            />
            <el-table-column
              prop="right_rate"
              label="正确率"
            />
            <el-table-column
              prop="result"
              label="结果"
            >
              <template slot-scope="scope">
                <div class="result">
                  <span :class="scope.row.result&&scope.row.result==='及格'?'bg1':scope.row.result&&scope.row.result==='不及格'?'bg2':'bg3'" />{{ scope.row.result }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane> -->
      <!-- <el-tab-pane label="章节统计" name="2">
        <div v-if="testInfo.review_option&&testInfo.review_option.includes('chapter')">
          <div v-if="column.length>1" class="tab_list">
            <div v-for="(item,index) in column" :key="index" class="tab" :class="item.id===tabIndex?'active':''" @click="columnChange(item)">{{ item.title }}</div>
          </div>
          <el-table
            :header-cell-style="{background:'#F7F8FA',fontSize: '14px',color:'#606060'}"
            :cell-style="{fontSize: '14px',color:'#303030',borderColor:'#eeeee'}"
            :data="tableData2"
            style="width: 100%"
            row-key="id"
            :tree-props="{children: 'child'}"
            height="500"
          >
            <el-table-column
              prop="title"
              label="章节"
            />
            <el-table-column
              prop="name"
              label="详情"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.child" class="chapter">
                  <span class="span">共{{ scope.row.question_count }}题</span>
                  <span class="span">错{{ scope.row.wrong_count }}题</span>
                  <span class="span">错误率：<span :class="scope.row.wrong_rate==='100%'?'cor1':scope.row.wrong_rate==='0%'?'cor2':'cor3'">{{ scope.row.wrong_rate }}</span></span>
                </div>
                <div v-else class="joint">
                  <span class="span">得分{{ scope.row.right_question_score }}分</span>
                  <span class="span">满分{{ scope.row.question_score }}分</span>
                  <span class="span">得分率：<span :class="scope.row.right_question_score_rate==='100%'?'cor2':scope.row.right_question_score_rate==='0%'?'cor1':'cor3'">{{ scope.row.right_question_score_rate }}</span></span>
                </div>
              </template></el-table-column>
          </el-table>
        </div>
      </el-tab-pane> -->
    </el-tabs>
  </el-dialog>
</template>
<script>
import { getTime } from '@/utils/index'
import { getRankList, getUserAnswerStatistics } from '@/http/index'
export default {
  filters: {
    filterTime(time) {
      if (time) {
        return getTime(time)
      } else {
        return '0'
      }
    }
  },
  props: {
    statisticsVisible: {
      type: Boolean,
      default: false
    },
    testInfo: {
      type: Object,
      default() { return {} }
    },
    statisticsType: {
      type: String,
      default: '0'
    },
    examDetailed: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      activeName: 1,
      tableData: [],
      tableData2: [],
      formLabelAlign: {
        page: 1,
        size: 10,
        total: 0
      },
      tabIndex: null,
      column: [],
      tableTemData: [],
      own_rank: null,
      testUserInfo: {},
      percentage: 0,
      colors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#6f7ad3', percentage: 100 }
      ]
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.statisticsVisible;
      },
      set(val) {
        this.$emit("update:statisticsVisible", val);
      }
    }
  },
  watch: {
    'statisticsVisible': { // $route可以用引号，也可以不用引号  监听的对象
      async handler(val) {
        if (val) {
          try {
            this.activeName = this.statisticsType.toString();
            await this.getScoreTotal();
            await this.getChapterTotal();
            await this.getProgress()
          } catch (error) {
          }
        }
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true // 第一次初始化渲染就可以监听到
    }
  },
  methods: {
    getProgress() {
      this.$nextTick(() => {
        try {
          const myChart = this.$echarts.init(
            document.getElementById("myChart")
          );
          const rate = this.testUserInfo.rate;
          const option = {
            angleAxis: {
              axisLine: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              min: 0,
              max: 133.5,
              boundaryGap: ['0', '100'],
              startAngle: 225
            },
            radiusAxis: {
              type: 'category',
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false
              },
              data: ['a', 'b', 'c'],
              z: 10
            },
            polar: {
              radius: '80%'
            },
            series: [{
              type: 'bar',
              data: [0, 0, rate],
              coordinateSystem: 'polar',
              barMaxWidth: 20,
              z: 2,
              roundCap: true,
              color: '#DD594A',
              barGap: '100%'
            }, {
              type: 'bar',
              data: [0, 0, 100],
              z: 0,
              silent: true,
              coordinateSystem: 'polar',
              barMaxWidth: 20,
              name: 'C',
              roundCap: true,
              color: '#eee',
              barGap: '-100%'
            }],
            tooltip: {
              show: false
            }
          }
          myChart.setOption(option);
          this.chartResize("chapter");
        } catch (error) {
          console.log(error, '???')
        }
      })
    },
    chartResize(domId) {
      const myChart = this.$echarts.init(document.getElementById(domId));
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    rowStyle({ row, rowIndex }) {
      if (rowIndex === 0) {
        return { 'background': 'linear-gradient(90deg, #FFEDED 0%, rgba(255,255,255,0) 100%)' };
      } else {
        return {};
      }
    },
    paginationChange(data) {
      this.formLabelAlign.page = data.page;
      this.formLabelAlign.size = data.size;
      this.getScoreTotal();
    },
    async getScoreTotal() {
      if (this.$route.query.type == 'review'){
      const res = await getRankList({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        user_id: this.$store.state.userInfo.user_id,
        exam_id: this.$route.query.id,
        page: this.formLabelAlign.page,
        size: this.formLabelAlign.size
      })
      if (res.code === 200) {
        this.own_rank = res.data.own_rank;
        this.tableData = res.data.ranking;
        this.tableData.unshift(res.data.own)
        this.formLabelAlign.total = res.data.number_of_test;
          this.testUserInfo = {
            avatar: res.data.own.avatar,
            realname: res.data.own.realname,
            score: res.data.own.score,
            time: res.data.own.exam_time,
            pass: res.data.own.result,
            rate: (res.data.own.score / res.data.exam_score * 100).toFixed(1),
            tips: this.examDetailed.result == 3 ? '' : this.examDetailed.result == 2 && this.examDetailed.review == 0 ? '考试整体结束时可以通过回顾考试查看答题记录和成绩' : this.examDetailed.result == 2 && this.examDetailed.review == 1 ? '可以通过回顾考试查看答题记录和成绩' : this.examDetailed.result == 1 && this.examDetailed.review == 0 ? '考试整体结束时可以通过回顾考试查看答题记录和排名' : '可以通过回顾考试查看答题记录和排名'
          }
      }
      }else{
        this.testUserInfo = this.testInfo;
      }
    },
    handleClose() {
      this.isOpen = false;
    },
    handleClick(e) {
      // if (e.index === '1') {
      //   this.getScoreTotal();
      // } else if (e.index === '2') {
      //   this.tabIndex = null;
      //   this.tableData2 = [];
      //   this.getChapterTotal();
      // }
    },
    async getChapterTotal() {
      const res = await getUserAnswerStatistics({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        exam_id: this.$route.query.id
      })
      if (res.code === 200) {
        this.column = [];
        res.data.forEach(item => {
          this.column.push({
            title: item.title,
            id: item.id
          })
          this.tableTemData = res.data;
          this.tabIndex = this.tableTemData[0].id;
          this.tableData2 = this.tableTemData[0].child;
        });
      }
    },
    columnChange(data) {
      this.tabIndex = data.id;
      this.tableData2 = this.tableTemData.find(item => item.id === data.id).child;
    }
  }
}
</script>
<style lang="scss" scoped>
.myChart{
  width: 300px;
  height: 300px;
}
::v-deep{
  .el-dialog__body{
    padding: 0;
  }
  .el-tabs__header {
    padding: 12px 24px 0 24px;
    background-color:#F7F8FA; ;
    margin: 0 !important;

  }
  .el-dialog__headerbtn{
    z-index: 10000;
  }
  .el-tabs__nav-wrap::after{
    background-color: #EEEEEE;
    height: 1px;
  }
  .el-dialog__header{
    padding: 0;
  }
  .el-tabs{
    margin: 0 !important;
  }
  .el-progress-circle{
    height: 148px !important;
  }
  .el-tabs__active-bar{
    width: 24px !important;
    left: 14px;
  }
  .el-tabs__content{
    padding: 24px;
  }
}
.tab_tips{
  font-size: 12px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #606060;
  margin: 16px 0;
  display: flex;
  align-items: center;
  .data_img{
    width:12px;
    margin-right: 4px;
  }
}
.content{
    text-align: center;
    min-height: 400px;
    .avtar_img{
        width: 56px;
        height: 56px;
        border-radius: 50%;
        margin-top: 32px;
    }
    .name{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #303030;
        margin: 16px 0 32px 0;
    }
    .status{
        font-size: 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #303030;
        margin-bottom: 8px;
    }
    .tips{
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #909090;
        margin-bottom: 32px;
    }
    .tips2{
      font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #EE726C;
        margin-bottom: 32px;
    }
    .progress_box{
        position: relative;
        width: 300px;
        margin: auto;
        background-color: linear-gradient(71deg, rgba(255, 142, 129, 1), rgba(221, 89, 74, 1)) 12 12;
        border-radius: 50%;
        // border-image: linear-gradient(71deg, rgba(255, 142, 129, 1), rgba(221, 89, 74, 1)) 12 12;
        .progress_text{
            width: 100%;
            text-align: center;
            position: absolute;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            color: #BFBFBF;
            top:32%;
            .progress_scope{
                font-size: 48px;
                font-family: Roboto, Roboto;
                font-weight: bold;
                color: #303030;
            }
        }
        .cor1{
                background-color: #5FCA71;
                color: #fff;
            }
            .cor2{
                color: #fff;
                background-color: #EB5C55;
            }
            .cor3{
                color: #fff;
                background-color: #4693F7;
            }
            .tags{
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                padding: 2px 8px;
                border-radius: 2px;
                margin-left: 16px;
                position: absolute;
                top: 0;
                right: -40px;

            }
    }
    .exam_name{
        margin:0 0 20px 0;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #303030;
        position: relative;
        top: 10%;
    }
}
.user{
    display: flex;
    align-items: center;
    .avtar{
        width: 56px;
        height: 56px;
        border-radius: 50%;
    }
    .info{
        margin-left: 16px;
        .name{
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: bold;
            color: #303030;
            margin-bottom: 6px;
        }
        .info_content{
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #909090;
            display: flex;
            align-items: center;
            .info_value{
                color: #606060;
                margin-right: 16px;
                font-size: 14px;
            }
            .cor{
                color: #DD594A;
                font-size: 14px;
                margin: 0 3px;
            }

        }
    }
}
.el-tabs{
    margin-top: 16px;
}
.tab_list{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .tab{
        cursor: pointer;
        font-size: 14px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #606060;
        padding: 6px 12px;
        border: 1px solid #EEEEEE;
        border-radius: 4px;
        margin-right: 8px;
        margin-bottom: 6px;
    }
    .active{
      color: #303030;
      font-weight: 500;
    }
}
.chapter,.joint{
  .span{
    margin-right: 30px;
  }
}
.cor1{
  color: #EB5C55;
}
.cor2{
  color:#5FCA71;
}
.cor3{
  color:#303030;
}
.table_user{
  display: flex;
  align-items: center;
  .user_img{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 8px;
  }
}
.result{
  display: flex;
  align-items: center;
  span{
    display: inline-block;
    width: 5px;
    height: 5px;
    margin-right: 8px;
    border-radius: 50%;
  }
}
.bg1{
  background-color: #5FCA71;
}
.bg2{
  background-color: #EB5C55;
}
.bg3{
  background-color: #4693F7;
}
.no_img{
  width: 14px;
}

  </style>

